"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalContentPadding = exports.TitleBoxContainer = exports.ModalContent = exports.ModalWrapper = exports.ModalBox = exports.ModalContainer = exports.ModalCloseButton = exports.TitleRightContent = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _StyledLayout = require("../StyledLayout");

var _StyledTypography = require("../StyledTypography");

var _MediaQueries = _interopRequireDefault(require("../MediaQueries"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ICON_SIZE = 48; // iconSizeLg

var ICON_MARGIN_TOP = 24;

var TitleRightContent = _styledComponents["default"].div.withConfig({
  displayName: "Elements__TitleRightContent",
  componentId: "olfmpd-0"
})(["display:none;", ""], _MediaQueries["default"].minWidth.medium(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    display: block;\n    position: absolute;\n    right: ", ";\n  "])), function (props) {
  return props.theme.spacingSm;
}));

exports.TitleRightContent = TitleRightContent;

var ModalCloseButton = _styledComponents["default"].div.withConfig({
  displayName: "Elements__ModalCloseButton",
  componentId: "olfmpd-1"
})(["svg{path{fill:", ";}}"], function (props) {
  return props.theme.veryDarkGrey;
});

exports.ModalCloseButton = ModalCloseButton;

var ModalContainer = _styledComponents["default"].div.withConfig({
  displayName: "Elements__ModalContainer",
  componentId: "olfmpd-2"
})(["display:", ";justify-content:center;align-items:center;position:fixed;background-color:", ";z-index:5;height:100%;width:100%;top:0;left:0;margin-left:0 !important;overflow:hidden;", ""], function (props) {
  return props.visible ? 'flex' : 'none';
}, function (props) {
  return props.masked && 'rgba(34, 34, 34, 0.4)';
}, function (props) {
  return props.fullScreen && !props.fullScreenHeight && _MediaQueries["default"].minWidth.topnavMobile(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n    top: 72px;\n    height: calc(100% - 72px);\n  "])));
});

exports.ModalContainer = ModalContainer;

var ModalBox = _styledComponents["default"].div.withConfig({
  displayName: "Elements__ModalBox",
  componentId: "olfmpd-3"
})(["width:100%;height:100%;max-height:100%;overflow:hidden;background-color:", ";display:flex;flex-direction:column;border-radius:", ";button{width:100%;}", ";", ""], function (props) {
  return props.theme.white;
}, function (props) {
  return (props.secondary || props.dialog) && props.theme.borderRadiusSm;
}, _MediaQueries["default"].minWidth.small(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n    height: ", ";\n    max-height: 100%;\n    border-radius: ", ";\n\n    button {\n      width: auto;\n    }\n  "])), function (props) {
  return props.fullHeight ? '100%' : 'initial';
}, function (props) {
  return props.theme.borderRadiusSm;
}), function (props) {
  return (props.width || props.height) && (0, _styledComponents.css)(["border-radius:", ";"], props.theme.borderRadiusSm);
});

exports.ModalBox = ModalBox;

var ModalWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Elements__ModalWrapper",
  componentId: "olfmpd-4"
})(["width:100%;height:100%;max-height:100%;display:flex;align-items:center;justify-content:center;", " ", " ", " ", " ", ""], function (props) {
  return (props.secondary || props.dialog) && (0, _styledComponents.css)(["height:auto;padding:", ";"], props.theme.spacingSm);
}, _MediaQueries["default"].minWidth.small(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n    padding: ", ";\n\n    ", "\n\n    ", "\n\n    ", "\n\n     ", "\n\n    ", "\n  "])), function (props) {
  return props.theme.spacingLg;
}, function (props) {
  return props.size === 'medium' && (0, _styledComponents.css)(["width:528px;height:736px;"]);
}, function (props) {
  return props.size === 'large' && (0, _styledComponents.css)(["width:1088px;height:768px;", "{height:768px;max-height:100%;}"], ModalBox);
}, function (props) {
  return props.width && (0, _styledComponents.css)(["width:", ";padding-left:0;padding-right:0;"], "".concat(props.width, "px"));
}, function (props) {
  return props.height && (0, _styledComponents.css)(["height:", ";padding-top:0;padding-bottom:0;"], "".concat(props.height, "px"));
}, function (props) {
  return props.fullScreen && (0, _styledComponents.css)(["height:100vh;width:100vw;padding:0;"]);
}), function (props) {
  return props.width && (0, _styledComponents.css)(["width:", ";"], "".concat(props.width, "px"));
}, function (props) {
  return props.height && (0, _styledComponents.css)(["height:", ";"], "".concat(props.height, "px"));
}, function (props) {
  return props.fullScreen && (0, _styledComponents.css)(["height:100vh;width:100vw;"]);
});

exports.ModalWrapper = ModalWrapper;

var ModalContent = _styledComponents["default"].div.withConfig({
  displayName: "Elements__ModalContent",
  componentId: "olfmpd-5"
})(["flex:1;overflow-x:hidden;overflow-y:overlay;position:relative;padding:", ";padding-top:", ";padding-bottom:", ";padding-left:", ";padding-right:", ";-ms-overflow-style:-ms-autohiding-scrollbar;outline:none;", ";"], function (props) {
  return props.theme.spacingSm;
}, function (props) {
  return props.hasTitle && '0';
}, function (props) {
  return props.infiniteScroll && '0';
}, function (props) {
  return props.fullWidth && '0';
}, function (props) {
  return props.fullWidth && '0';
}, _MediaQueries["default"].minWidth.small(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n    padding: ", ";\n    padding-top: ", ";\n    padding-bottom: ", ";\n    padding-left: ", ";\n    padding-right: ", ";\n  "])), function (props) {
  return props.size !== 'large' && props.theme.spacingMd;
}, function (props) {
  return props.hasTitle && '0';
}, function (props) {
  return props.infiniteScroll && '0';
}, function (props) {
  return props.fullWidth && '0';
}, function (props) {
  return props.fullWidth && '0';
}));

exports.ModalContent = ModalContent;
var TitleBoxContainer = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__TitleBoxContainer",
  componentId: "olfmpd-6"
})(["display:flex;flex-direction:column;align-items:center;justify-content:center;position:relative;width:100%;height:", "px;flex:0 0 ", "px;box-shadow:", ";", "{text-align:center;width:100%;}", ";", "{position:absolute;left:", ";top:", ";}", ";"], function (props) {
  return props.svg ? 52 + ICON_SIZE + ICON_MARGIN_TOP : 52;
}, function (props) {
  return props.svg ? 52 + ICON_SIZE + ICON_MARGIN_TOP : 52;
}, function (props) {
  return props.scrolled && props.theme.boxShadowMdBottom;
}, _StyledTypography.HeadingSmall, function (props) {
  return props.size === 'large' && (0, _styledComponents.css)(["height:", "px;flex:0 0 ", "px;", "{left:", ";top:", ";}"], props.svg ? 72 + ICON_SIZE + ICON_MARGIN_TOP : 72, props.svg ? 72 + ICON_SIZE + ICON_MARGIN_TOP : 72, ModalCloseButton, props.theme.spacingSm, props.svg ? "".concat(ICON_MARGIN_TOP, "px") : 'unset');
}, ModalCloseButton, function (props) {
  return props.theme.spacingSm;
}, function (props) {
  return props.svg ? "".concat(ICON_MARGIN_TOP, "px") : 'unset';
}, _MediaQueries["default"].minWidth.small(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n      height: ", "px;\n      flex: 0 0 ", "px;\n\n      ", " {\n        left: ", ";\n        top: ", ";\n      }\n  "])), function (props) {
  return props.svg ? 72 + ICON_SIZE + ICON_MARGIN_TOP : 72;
}, function (props) {
  return props.svg ? 72 + ICON_SIZE + ICON_MARGIN_TOP : 72;
}, ModalCloseButton, function (props) {
  return props.theme.spacingMd;
}, function (props) {
  return props.svg ? "".concat(ICON_MARGIN_TOP, "px") : 'unset';
}));
exports.TitleBoxContainer = TitleBoxContainer;

var ModalContentPadding = _styledComponents["default"].div.withConfig({
  displayName: "Elements__ModalContentPadding",
  componentId: "olfmpd-7"
})(["padding:", ";padding-top:", ";padding-bottom:", ";", ""], function (props) {
  return props.theme.spacingSm;
}, function (props) {
  return props.top && props.theme.spacingSm || '0';
}, function (props) {
  return props.bottom && props.theme.spacingSm || '0';
}, _MediaQueries["default"].minWidth.small(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n    ", ";\n\n    ", "\n  "])), function (props) {
  return props.size !== 'large' && (0, _styledComponents.css)(["padding:", ";padding-top:", ";padding-bottom:", ";"], props.theme.spacingMd, props.top && props.theme.spacingMd || '0', props.bottom && props.theme.spacingMd || '0');
}, function (props) {
  return props.buttonPosition && (0, _styledComponents.css)(["display:flex;justify-content:", ";"], props.buttonPosition || 'center');
}));

exports.ModalContentPadding = ModalContentPadding;